<script lang="ts">
    import VideoJs from "../widgets/VideoJs.svelte"

    export let baseURL: string
    export let item: ContentSlide
</script>

<div class="slide">
    <div class="image">
        {#if item.videoPath}
            <!-- HLS Video -->
            <VideoJs src="{item.videoPath}" controls="{false}" autoplay loop muted preload="auto" />
        {:else}
            <picture>
                <source media="(min-width: 768px)" srcset="{baseURL + item.image?.src + '?filter=xl'}" />
                <source srcset="{baseURL + item.image?.src + '?filter=l'}" />
                <img src="{baseURL + item.image?.src + '?filter=l'}" alt="{item.title || ''}" />
            </picture>
        {/if}
    </div>
    <div class="text">
        <div class="container">
            <div class="text_inner animated">
                {#if item.title}
                    <div class="headline">{item.title}</div>
                {/if}
                {#if item.button_text && item.button_url}
                    <a href="{item.button_url}" class="btn btn-secondary">{item.button_text}</a>
                {/if}
            </div>
        </div>
    </div>
</div>
